var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgComment = function SvgComment(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99793 1C6.73211 1.0004 5.49009 1.34413 4.40416 1.99458C3.31824 2.64504 2.42908 3.57786 1.83139 4.6937C1.2337 5.80954 0.949864 7.0666 1.01011 8.33099C1.07035 9.59538 1.47243 10.8198 2.1735 11.8737L1 14.9959L4.92961 14.2853C5.87585 14.7477 6.91425 14.9906 7.96741 14.9958C9.02057 15.001 10.0613 14.7684 11.0121 14.3154C11.9629 13.8624 12.7991 13.2007 13.4585 12.3795C14.118 11.5583 14.5835 10.5989 14.8205 9.5727C15.0575 8.54654 15.0598 7.48012 14.8273 6.45293C14.5948 5.42574 14.1334 4.46429 13.4776 3.64023C12.8218 2.81617 11.9884 2.15077 11.0396 1.69363C10.0908 1.23648 9.05111 0.999379 7.99793 1V1Z",
    stroke: "#797979",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgComment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comment.319007acbc4eab449884c1513a99d18a.svg";